<template>
    <!-- Card style from the report designs: a switch, the label, and the
         description behind an info icon. -->
    <div    v-if="variant === 'cards'"
            class="report-settings-band flex items-center gap-3 rounded-md px-2 py-3">
        <button :id="field.key"
                type="button"
                role="switch"
                :aria-checked="!! modelValue"
                :aria-label="field.label"
                class="relative inline-flex h-6 w-10 shrink-0 items-center rounded-full transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                :class="modelValue ? 'bg-green-500' : 'bg-gray-300'"
                @click="$emit('update:modelValue', ! modelValue)"
        >
            <span   class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white shadow transition-transform duration-150"
                    :class="modelValue ? 'translate-x-[1.125rem]' : 'translate-x-0.5'"
            >
                <tabler-icon    v-if="modelValue"
                                name="check"
                                size-class="h-3 w-3 text-green-500"
                                :stroke-width="3"
                ></tabler-icon>
            </span>
        </button>

        <label  :for="field.key"
                class="m-0 cursor-pointer text-sm text-gray-900">{{ field.label }}</label>

        <info-tip v-if="field.description"
                      :text="field.description"
            ></info-tip>

        <p  v-if="error"
            class="m-0 ml-auto text-xs text-red-500">
            {{ error }}
        </p>
    </div>

    <report-field-row   v-else
                        :field-id="field.key"
                        :label="field.label"
                        :description="field.description"
                        :error="error"
                        :inline="true"
    >
        <!-- A labeled Include/Exclude switch instead of a bare toggle, so it is
             explicit what turning the option on actually does. Schemas may
             override the wording with onLabel/offLabel per field. -->
        <segmented-toggle   :model-value="!! modelValue"
                            :on-label="field.onLabel || 'Include'"
                            :off-label="field.offLabel || 'Exclude'"
                            :aria-label="field.label"
                            @update:model-value="$emit('update:modelValue', $event)"
        ></segmented-toggle>
    </report-field-row>
</template>

<script>
import ReportFieldRow from "../ReportFieldRow.vue"
import SegmentedToggle from "@/components/elements/SegmentedToggle.vue"
import InfoTip from "@/components/elements/InfoTip.vue"
import TablerIcon from "@/components/elements/TablerIcon.vue"

export default {
    name: "ReportToggleField",
    components: {ReportFieldRow, SegmentedToggle, InfoTip, TablerIcon},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        field: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            default: null,
        },
        // 'list' or 'cards'; see ReportSettingsPanel.
        variant: {
            type: String,
            default: 'list',
        },
    },
}
</script>
